import { CompanyDto } from './company.dto';
import { IContacts } from './contacts';
import { IPerson } from './person.dto';
import { DownloadFileDto } from './download-file.dto';


export class PriceInfoDto {
  id: number;
  isActive: boolean;
  companyInfo: CompanyDto;
  companyContacts: IContacts;
  updatedBy: IPerson;
  createdAt: Date;
  mainFile: DownloadFileDto;
  extraFiles: DownloadFileDto[];
}


export class CreatePriceDto {
  mainFile: DownloadFileDto;
  extraFiles: DownloadFileDto[];
  companies: string;
  media: number;
}
